// extracted by mini-css-extract-plugin
export default {"description":"CloneLayoutModal_description__nZWF4","input":"CloneLayoutModal_input__DJQjX","buttons":"CloneLayoutModal_buttons__wZg4M"};